const statisticsHr = {
    "user_statistics": "Statistika korisnika",
    "menu_item_clicks": "Klikovi na stavke izbornika",
    "statistics": "Statistika",
    "user_traffic": "Promet korisnika",
    "last_7_days": "Posljednjih 7 dana",
    "last_30_days": "Posljednjih 30 dana",
    "menu_item": "Stavka izbornika",
    "click_count": "Broj klikova",
    "error_fetching_user_statistics": "Pogreška pri dohvaćanju korisničke statistike.",
    "error_fetching_menu_item_statistics": "Pogreška pri dohvaćanju statistike stavke izbornika.",
    "statistics_feature_not_available": "Značajka statistike dostupna je samo u PRO planu. Nadogradite svoju pretplatu kako biste pristupili ovoj značajki.",
    "change_subscription_plan": "Promjena pretplatničkog plana",
    "permission_denied": "Dozvola odbijena",
    "error_fetching_rating_statistics": "Pogreška pri dohvaćanju statistike ocjenjivanja.",
    "menu_item_ratings": "Ocjene stavki na jelovniku",
    "likes": "sviđanja",
    "dislikes": "nesviđanja",
    "rating_trends_last_7_days": "Trendovi ocjenjivanja (zadnjih 7 dana)",
    "rating_trends_last_30_days": "Trendovi ocjenjivanja (zadnjih 30 dana)"
};

export default statisticsHr;
